import React from 'react';

const TemplatingContext = React.createContext();

export default TemplatingContext;
